import { Component } from '@angular/core';

@Component({
  selector: 'app-digital-queue-list',
  templateUrl: './digital-queue-list.component.html',
  styleUrls: ['./digital-queue-list.component.scss']
})
export class DigitalQueueListComponent {

}
